export const allowedDocumentFileExtensions = [
  "pdf",
  "jpg",
  "jpeg",
  "png",
] as const;
export const allowedDocumentFileTypes = [
  "application/pdf",
  "image/jpeg",
  "image/png",
] as const;
export const imageExtensions = [".jpg", ".jpeg", ".png"] as const;
export const imageTypes = ["image/jpeg", "image/png"] as const;

// File upload size limits
export const MAX_UPLOAD_SIZE_MB = 10;
export const MAX_UPLOAD_SIZE = MAX_UPLOAD_SIZE_MB * 1024 * 1024; // 10MB in bytes

// Feature flags
// On only for the stage build (`vite build --mode staging` → .env.staging,
// stage.eventpin.com). Every other build mode keeps these hidden.
const IS_STAGING_BUILD = import.meta.env.MODE === "staging";

// Ticketing (My Tickets menu, Book Now button, Stripe Connect switch) is
// hidden from prod UI per client request until ticketing feature is needed.
export const TICKETING_ENABLED = IS_STAGING_BUILD;

// External platform export (Facebook/LinkedIn Connected Platforms section in
// OrganizationForm, Platforms step in event creation wizard) hidden from prod
// per client request.
export const EXTERNAL_PLATFORMS_ENABLED = IS_STAGING_BUILD;
